import { createAsyncThunk } from '@reduxjs/toolkit'
import MobileLoginProxy from './mobile-login-proxy-model'
import {
  delete_mobileLoginProxy,
  load_mobileLoginProxys,
  store_mobileLoginProxy,
} from './mobileLoginProxy-service'

export const LoadMobileLoginProxysAsync = createAsyncThunk<any, any>(
  'composer/load/mobileLoginProxy',
  async (params: { uid: string }) => {
    return await load_mobileLoginProxys(params)
  },
)

export const CreateMobileLoginProxyAsync = createAsyncThunk<any, any>(
  'composer/create/mobileLoginProxy',
  async (params: MobileLoginProxy) => {
    return await store_mobileLoginProxy(params)
  },
)

export const DeleteMobileLoginProxyAsync = createAsyncThunk<any, any>(
  'composer/delete/mobileLoginProxy',
  async (params) => {
    return await delete_mobileLoginProxy(params)
  },
)
